import type { RouteObject } from "react-router";

import PublicSite from "@/pages/PublicSite";

export const siteRoutes: RouteObject[] = [
  {
    path: "site/:slug",
    element: <PublicSite />,
  },
  {
    path: "site/:slug/:pageSlug",
    element: <PublicSite />,
  },
];
